import { Children, useState, useCallback } from 'react';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { usageTracker } from '../../usage-tracker/usageTracker';
import { getUsageTrackingChannel } from '../../usage-tracker/trackerChannelIdMapping';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
function PrimaryMessageContentSection({
  canExpand,
  genericChannelId,
  children,
  isLastMessage
}) {
  const [expanded, setExpanded] = useState(!!isLastMessage);
  const onCollapseButtonClick = useCallback(() => {
    usageTracker.track('see-less', {
      action: 'see less',
      channel: genericChannelId ? getUsageTrackingChannel(genericChannelId) : genericChannelId
    });
    setExpanded(false);
  }, [genericChannelId]);
  const onExpandButtonClick = useCallback(() => {
    usageTracker.track('see-more', {
      action: 'see more',
      channel: genericChannelId ? getUsageTrackingChannel(genericChannelId) : genericChannelId
    });
  }, [genericChannelId]);
  const expandMessage = useCallback(() => {
    if (!expanded) {
      setExpanded(true);
    }
  }, [expanded]);
  const renderContent = () => {
    if (!canExpand) {
      return /*#__PURE__*/_jsx(View, {
        "data-test-id": "primary-message-body-content",
        padding: "0",
        children: children
      });
    }
    return /*#__PURE__*/_jsx(ExpandableText, {
      onCollapseButtonClick: onCollapseButtonClick,
      onExpandButtonClick: onExpandButtonClick,
      expanded: expanded,
      maxHeight: 250,
      gradientColor: "fill-surface-default",
      children: /*#__PURE__*/_jsx(View, {
        "data-test-id": "primary-message-body-content",
        padding: "0",
        children: children
      })
    });
  };
  const hasContent = Children.count(children) > 0;
  if (!hasContent) return null;
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "primary-message-content-section",
    onClick: canExpand ? expandMessage : undefined,
    inlineSize: "100%",
    children: renderContent()
  });
}
PrimaryMessageContentSection.displayName = 'PrimaryMessageContentSection';
export default PrimaryMessageContentSection;